module.exports = __webpack_public_path__ + "img/logo.17605467.png";